import { useHttp, useTranslate } from '@/shared/lib'
import { computed, type Ref } from 'vue'
import { useMutation, useQuery } from '@tanstack/vue-query'
import { useNotification } from '@/shared/ui'

/**
 * Функция загрузки данных для виджета счетчики
 */
export const useLoadControlMeter = (meter_id: Ref<number>) => {
  const http = useHttp()

  const url = computed(() => `/cabinets/meters/get/${meter_id.value}/monitoring`)

  const queryKey = computed(() => ['load_control_meter', meter_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}

/**
 * Функция отправки команд для виджетов счетчика
 */
export const useSendControlMeterCommand = () => {
  const http = useHttp()

  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) =>
      http.post(`/cabinets/${data.object_id}/monitoring/meters-update`, data),
  })

  const send = async (order_number: number, type: string, object_id: number) => {
    try {
      await mutation.mutateAsync({ order_number, type, object_id })

      addSuccess(trs('itf.command_send'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    send,
  }
}
